import { default as Container } from './SoldProductsSection.container';
import { default as Component } from './SoldProductsSection';
export default Container(Component);
